<template>
  <div id="modalLancamentoDetalhamento">
    <q-dialog v-model="dialogAberto" persistent>
      <q-card style="max-width: 700px !important; width: 100%;">
        <q-card-section class="flex justify-between">
          <div class="text-h6">Detalhamento do Lançamento</div>
          <q-btn
            icon="close"
            flat
            round
            dense
            v-close-popup
            @click="closeModal()"
          />
        </q-card-section>
        <q-separator />
        <q-card-section>
          <div>
            <p>Descrição: <b>{{ movconta.descricao }}</b></p>
            <p>Conta: <b>{{ movconta.conta.titulo }}</b></p>
            <p>Valor: <b>R$ {{ $currency(movconta.valor) }}</b></p>
            <p>Criado por: <b>{{ movconta.criador }}</b></p>
          </div>
        </q-card-section>

        <q-card-section class="row">
          <div class="col-6">
            <p class="q-mb-none text-h6">Cédulas</p>

            <div class="text-right" style="width: 65%;">
              <p>R$ 2,00 x {{ movconta.movcontas_detalhenota.notas_2 }} = R$ {{ $currency(movconta.movcontas_detalhenota.notas_2 * 2) }}</p>
              <p>R$ 5,00 x {{ movconta.movcontas_detalhenota.notas_5 }} = R$ {{ $currency(movconta.movcontas_detalhenota.notas_5 * 5) }}</p>
              <p>R$ 10,00 x {{ movconta.movcontas_detalhenota.notas_10 }} = R$ {{ $currency(movconta.movcontas_detalhenota.notas_10 * 10) }}</p>
              <p>R$ 20,00 x {{ movconta.movcontas_detalhenota.notas_20 }} = R$ {{ $currency(movconta.movcontas_detalhenota.notas_20 * 20) }}</p>
              <p>R$ 50,00 x {{ movconta.movcontas_detalhenota.notas_50 }} = R$ {{ $currency(movconta.movcontas_detalhenota.notas_50 * 50) }}</p>
              <p>R$ 100,00 x {{ movconta.movcontas_detalhenota.notas_100 }} = R$ {{ $currency(movconta.movcontas_detalhenota.notas_100 * 100) }}</p>
              <p>R$ 200,00 x {{ movconta.movcontas_detalhenota.notas_200 }} = R$ {{ $currency(movconta.movcontas_detalhenota.notas_200 * 200) }}</p>
              <p><b>Total: R$ {{ $currency(valorTotalNotas) }}</b></p>
            </div>
          </div>

          <div class="col-6">
            <p class="q-mb-none text-h6">Moedas</p>

            <div class="text-right" style="width: 65%;">
              <p>R$ 0,05 x {{ movconta.movcontas_detalhemoeda.moedas_5 }} = R$ {{ $currency(movconta.movcontas_detalhemoeda.moedas_5 * 0.05) }}</p>
              <p>R$ 0,10 x {{ movconta.movcontas_detalhemoeda.moedas_10 }} = R$ {{ $currency(movconta.movcontas_detalhemoeda.moedas_10 * 0.1) }}</p>
              <p>R$ 0,25 x {{ movconta.movcontas_detalhemoeda.moedas_25 }} = R$ {{ $currency(movconta.movcontas_detalhemoeda.moedas_25 * 0.25) }}</p>
              <p>R$ 0,50 x {{ movconta.movcontas_detalhemoeda.moedas_50 }} = R$ {{ $currency(movconta.movcontas_detalhemoeda.moedas_50 * 0.5) }}</p>
              <p>R$ 1,00 x {{ movconta.movcontas_detalhemoeda.moedas_1 }} = R$ {{ $currency(movconta.movcontas_detalhemoeda.moedas_1) }}</p>
              <p><b>Total: R$ {{ $currency(valorTotalMoedas) }}</b></p>
            </div>
          </div>
        </q-card-section>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: 'modalLancamentoDetalhamento',

  emits: ["closeModal"],
  props: ['movconta', 'openModalLancamentoDetalhamento'],
  methods: {
    closeModal() {
      this.$emit('closeModal');
    }
  },
  computed: {
    // `v-model` direto numa prop e erro de compilacao no Vue 3
    // ("local prop bindings are not writable"). No Vue 2 funcionava com aviso,
    // mas silenciosamente: fechar por ESC ou clique fora mutava a copia local e o
    // pai nunca era avisado, entao o estado dele continuava aberto.
    dialogAberto: {
      get() {
        return this.openModalLancamentoDetalhamento;
      },
      set(aberto) {
        if (!aberto) this.$emit("closeModal");
      },
    },
    valorTotalNotas() {
      const { movcontas_detalhenota } = this.movconta;

      return (
        (parseInt(movcontas_detalhenota.notas_2) * 2)
        + (parseInt(movcontas_detalhenota.notas_5) * 5)
        + (parseInt(movcontas_detalhenota.notas_10) * 10)
        + (parseInt(movcontas_detalhenota.notas_20) * 20)
        + (parseInt(movcontas_detalhenota.notas_50) * 50)
        + (parseInt(movcontas_detalhenota.notas_100) * 100)
        + (parseInt(movcontas_detalhenota.notas_200) * 200)
      );
    },
    valorTotalMoedas() {
      const { movcontas_detalhemoeda } = this.movconta;

      return (
        (parseInt(movcontas_detalhemoeda.moedas_5) * 0.05)
        + (parseInt(movcontas_detalhemoeda.moedas_10) * 0.1)
        + (parseInt(movcontas_detalhemoeda.moedas_25) * 0.25)
        + (parseInt(movcontas_detalhemoeda.moedas_50) * 0.5)
        + (parseInt(movcontas_detalhemoeda.moedas_1))
      );
    },
    vencimento() {
      return moment(this.movconta.vencimento, 'YYYY/MM/DD').format('DD/MM/YYYY');
    }
  }
};
</script>

<style scoped>
p {
  margin-bottom: 4px;
}
</style>